import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import App from "./App";
import SessionProvider from "./auth/SessionProvider";
import { DATENSCHUTZ, IMPRESSUM } from "./legal/content.generated";
import { configureRuntime } from "./lib/runtimeConfig";
import LegalPage from "./routes/LegalPage";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("#root element missing from index.html");
}

void configureRuntime()
  .then(() => {
    createRoot(rootElement).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <SessionProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </SessionProvider>
        </QueryClientProvider>
      </StrictMode>,
    );
  })
  .catch(() => {
    createRoot(rootElement).render(
      <StrictMode>
        <BrowserRouter>
          <Routes>
            <Route path="/impressum" element={<LegalPage doc={IMPRESSUM} />} />
            <Route
              path="/datenschutz"
              element={<LegalPage doc={DATENSCHUTZ} />}
            />
            <Route path="*" element={<RuntimeUnavailable />} />
          </Routes>
        </BrowserRouter>
      </StrictMode>,
    );
  });

function RuntimeUnavailable() {
  return (
    <main className="mx-auto flex min-h-screen max-w-lg flex-col justify-center px-6">
      <h1 className="text-xl font-semibold text-slate-900">
        Anmeldung vorübergehend nicht verfügbar
      </h1>
      <p className="mt-2 text-sm text-slate-600" role="alert">
        Die sichere Verbindung zur Anmeldung konnte nicht vorbereitet werden.
        Bitte laden Sie die Seite in einigen Minuten erneut.
      </p>
    </main>
  );
}
